// API Gateway's `policy` field is double JSON-encoded and needs one unescape pass first
export const decodeAgwPolicyDocument = (document?: Optional<string>): string => {
  if (!document) return '';
  try {
    JSON.parse(document);
    return document;
  } catch {
    try {
      return JSON.parse(`"${document}"`);
    } catch {
      return document;
    }
  }
};
